export enum ChatAgent {
  ASSISTANT = "assistant",
  STORE_SETUP = "store_setup",
}
